// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueInvestissements = (newValue) => ({
  type: actionTypes.SET_VALUE_INVESTISSEMENT,
  payload: newValue,
});

export const setCurrentPageInvestissements = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_INVESTISSEMENT,
  payload: newCurrentPage,
});

export const setSortingInvestissements = (newSorting) => ({
  type: actionTypes.SET_SORTING_INVESTISSEMENT,
  payload: newSorting,
});
export const setPageSizeInvestissements = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_INVESTISSEMENT,
  payload: newValue,
});

export const setCustomFilterInvestissements = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_INVESTISSEMENT,
  payload: newValue,
});
export const setSortFieldInvestissements = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_INVESTISSEMENT,
  payload: newSortField,
});
export const setOrderInvestissements = (newOrder) => ({
  type: actionTypes.SET_ORDER_INVESTISSEMENT,
  payload: newOrder,
});
export const setActiveTabInvestissements = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_INVESTISSEMENT,
  payload: newActiveTab,
});
export const setQueryInvestissements = (newQuery) => ({
  type: actionTypes.SET_QUERY_INVESTISSEMENT,
  payload: newQuery,
});
export const setActifInvestissements = (newQuery) => ({
  type: actionTypes.SET_ACTIF_INVESTISSEMENT,
  payload: newQuery,
});
export const setSelectedOptionFiltersInvestissements = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_INVESTISSEMENT,
  payload: newQuery,
});
export const setSelectedOptionIdInvestissements = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_INVESTISSEMENT,
  payload: newQuery,
});

export const setColumnInvestissements = (newValue) => ({
  type: actionTypes.SET_COLUMN_INVESTISSEMENT,
  payload: newValue,
});
